import { Navigate, type RouteObject } from "react-router";

import { activityRouteChildren } from "@/pages/import/ActivityPage";
import { datalakesRouteChildren } from "@/pages/import/DatalakesPage";
import { datasetsRouteChildren } from "@/pages/import/DatasetsPage";
import { destinationsRouteChildren } from "@/pages/import/DestinationsPage";
import { providersRouteChildren } from "@/pages/import/ProvidersPage";
import { sourcesRouteChildren } from "@/pages/import/SourcesPage";
import { streamsRouteChildren } from "@/pages/import/StreamsPage";

export const importRoutes: RouteObject = {
  path: "import",
  handle: {
    breadcrumb: () => ({ label: "Import" }),
  },
  children: [
    {
      index: true,
      element: <Navigate to="/import/activity" replace />,
    },
    activityRouteChildren,
    datalakesRouteChildren,
    datasetsRouteChildren,
    providersRouteChildren,
    destinationsRouteChildren,
    sourcesRouteChildren,
    streamsRouteChildren,
  ],
};
